import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcTopbarWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderTopbar();
}
